import { Injectable } from '@angular/core';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { Observable, of, BehaviorSubject, Subject, forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { HttpService } from './http.service';
import { FunctionalPermissions } from 'app/model/shared/backend-api-response/functional-permissions';
import { GetLocationApiResponse } from 'model/shared/backend-api-response/get-location-api-response';
import { BookDataResponse } from 'model/wbe/backend-api-response/book-data-response';
import { CommonDataService } from 'modules/group/shared/commonData.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  public tenantId: any;
  public propertyId: any;
  public loginAuth = false;
  public delegateLogin = false;
  public confidentialRate: string = 'N';
  public groupsconfirmationdata: any;
  groupStartDate;
  groupEndDate;
  shoulderStartDate;
  shoulderEndDate;
  public plannerLogin = false;
  server_name: any;
  public groupDetails: any = '';
  public groupInvDetails: any = '';
  public userName: any = '';
  public loginState = new BehaviorSubject('default');
  public changeTheme = new BehaviorSubject({});
  public servername: string = '';
  grpEvents: any;
  azureStorageLink: string;
  public showCreditCard: boolean = false;
  public groupFunctionalPermission: FunctionalPermissions;
  public groupRateService: string = 'wbe-rate-service';
  public groupBannerImageChange = new BehaviorSubject('default');
  public plannerConfigureDataUpdate = new BehaviorSubject('default');
  public isAzureB2CAuthenticationEnabled: boolean = false;

  constructor(
    public appinit: LegacyBookInitService,
    public http: HttpClient,
    public router: Router,
    public httpService: HttpService,
    public commonDataService: CommonDataService
  ) {
    this.tenantId = this.appinit.tenantId;
    this.propertyId = this.appinit.propertyId;
    this.servername = appinit.getserverDetails_book();
    this.azureStorageLink = this.appinit.PropertyData.UrlMap.AzureBoxUrl;
    this.groupFunctionalPermission = this.appinit.PropertyData.groupPermissions.functionalPermissions;
    if (environment.isAzureB2CAuthenticationEnabled === 'true') {
      this.isAzureB2CAuthenticationEnabled = true;
    }
  }

  login(username, password) {
    return new Promise((resolve, reject) => {
      let masterResponse: any = {};
      let url =
        this.appinit.getCloudDomainName() +
        '/wbe-rate-service/' +
        'grouplogin/tenants/' +
        this.tenantId +
        '/propertyId/' +
        this.appinit.propertyId +
        '/appName/' +
        this.appinit.appName +
        '/groupLogin?appName=wbe';
      let postHeaders = Object.assign(this.appinit.serviceHeaders.headers, {
        'Content-Type': 'application/json',
        user: username,
        password: password,
      });
      let body = {
        user: username,
        password: password,
      };
      this.httpService.get(url, { headers: postHeaders }).subscribe((resp) => {
        if (resp['success']) {
          masterResponse = Object.assign({}, masterResponse, resp);
          // return resp;
          this.uploadCss(username);
          this.getOtherDetails(username).subscribe(
            (gdetails) => {
              gdetails.forEach((item) => {
                if (item['success']) {
                  masterResponse = Object.assign({}, masterResponse, item);
                }
                if (gdetails[0]['success']) {
                  let details =
                    gdetails[0]['groups'] && gdetails[0]['groups'].length > 0 ? gdetails[0]['groups'][0] : gdetails[0]['groups'];
                  this.getInventryDetails(details.groupId).subscribe(
                    (inres) => {
                      if (inres['success']) {
                        if (inres['groupInventory']) {
                          if (!inres['groupInventory'].length) {
                            reject(this.appinit.PropertyData.rGuestMessages.groups.loginInventryFailed);
                            return;
                          }
                        } else {
                          reject(this.appinit.PropertyData.rGuestMessages.groups.loginInventryFailed);
                          return;
                        }
                        masterResponse = Object.assign({}, masterResponse, inres);
                        let res = masterResponse;
                        if (res && res['success']) {
                          this.loginAuth = true;
                          if (res['isGroupPlannerPwd'] === true) {
                            sessionStorage.setItem('PlannerUser', JSON.stringify(body));
                            this.plannerLogin = true;
                            this.delegateLogin = false;
                          } else if (res['isGroupPlannerPwd'] === false) {
                            sessionStorage.setItem('DelegateUser', JSON.stringify(body));
                            this.plannerLogin = false;
                            this.delegateLogin = true;
                          }
                          this.userName = username;
                          let newGroup = false;
                          if (!this.groupDetails) newGroup = true;
                          this.groupDetails = res['groups'] && res['groups'].length > 0 ? res['groups'][0] : res['groups'];
                          this.grpEvents = res['events'];
                          if (newGroup) {
                            this.groupStartDate = this.groupDetails.arrivalDate;
                            this.groupEndDate = this.groupDetails.departureDate;
                            this.shoulderStartDate = this.groupDetails.shoulderStartDate;
                            this.shoulderEndDate = this.groupDetails.shoulderEndDate;
                            this.confidentialRate = this.groupDetails.confidentialRate || this.confidentialRate;
                          }
                          this.groupInvDetails = res['groupInventory'];
                          if (this.groupDetails) {
                            this.groupDetails['offer'] = this.groupDetails.offer ? this.groupDetails.offer : [];
                          }
                          this.checkcreditcardstatus();
                          this.loginState.next('loggedIn');
                        }
                        resolve(masterResponse);
                      } else {
                        reject(inres);
                        catchError(this.handleError('Group Login Failed.', {}));
                        return null;
                      }
                    },
                    (err) => {
                      reject(err);
                      catchError(this.handleError('Group Login Failed.', {}));
                    }
                  );
                } else {
                  reject(gdetails[0]);
                  catchError(this.handleError('Group Login Failed.', {}));
                }
              });
            },
            (err) => {
              reject(err);
              catchError(this.handleError('Group Login Failed.', {}));
            }
          );
        } else {
          reject(resp);
          catchError(this.handleError('Group Login Failed.', {}));
        }
      });
    });
  }

  checkcreditcardstatus() {
    if (this.plannerLogin) {
      if (!this.groupFunctionalPermission.creditCardPlanner) {
        if (this.groupDetails.creditCardDisablePlanner) {
          this.showCreditCard = false;
        } else {
          this.showCreditCard = true;
        }
      } else {
        this.showCreditCard = false;
      }
    } else {
      if (!this.groupFunctionalPermission.creditCardDelegate) {
        if (this.groupDetails.creditCardDisableDelegate) {
          this.showCreditCard = false;
        } else {
          this.showCreditCard = true;
        }
      } else {
        this.showCreditCard = false;
      }
    }
  }

  urlEncode(inputString) {
    return encodeURIComponent(inputString);
  }

  getOtherDetails(groupcode) {
    groupcode = this.urlEncode(groupcode);
    let url1 =
      this.appinit.getCloudDomainName() +
      '/wbe-rate-service/' +
      'grouplogin/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.appinit.propertyId +
      '/appName/' +
      this.appinit.appName +
      '/groupDetails?appName=wbe&groupCode=' +
      groupcode;
    let url2 =
      this.appinit.getCloudDomainName() +
      '/wbe-rate-service/' +
      'grouplogin/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.appinit.propertyId +
      '/appName/' +
      this.appinit.appName +
      '/groupEvent?appName=wbe&groupCode=' +
      groupcode;
    let groupDetails = this.httpService.get(url1, this.appinit.serviceHeaders);
    let eventDetaisl = this.httpService.get(url2, this.appinit.serviceHeaders);
    return forkJoin([groupDetails, eventDetaisl]);
  }

  public getGroupDetails(groupCode, arrDdate, depDate): Observable<any> {
    groupCode = this.urlEncode(groupCode);
    let url =
      this.appinit.getCloudDomainName() +
      '/wbe-rate-service/' +
      'grouplogin/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.appinit.propertyId +
      '/appName/' +
      this.appinit.appName +
      `/groupDetails?arrivalDate=${arrDdate}&departureDate=${depDate}&groupCode=${groupCode}`;
    return this.httpService.get(url, this.appinit.serviceHeaders).pipe(
      tap((res) => {
        return res;
      }),
      catchError(this.handleError('Group Details Failed.', {}))
    );
  }

  uploadCss(username) {
    this.http
      .get(
        this.azureStorageLink +
          '/wbe/' +
          this.appinit.tenantId +
          '/' +
          this.appinit.propertyId +
          '/styles/group/' +
          username.toLowerCase() +
          '.css' +
          '?' +
          new Date().getTime() +
          `&${this.appinit.azureBlobTokenKey}`,
        { responseType: 'text' }
      )
      .subscribe(
        (data) => {
          this.appinit.injectStylesheet(data, 'groupStyles');
          this.getCanvasColor(data);
        },
        (error) => {
          this.uploadDefaultCss();
        }
      );
  }

  uploadDefaultCss() {
    this.http
      .get(
        this.azureStorageLink +
          '/wbe/' +
          this.appinit.tenantId +
          '/' +
          this.appinit.propertyId +
          '/styles/' +
          this.appinit.tenantId +
          '-' +
          this.appinit.propertyId +
          '-wbe-group.css' +
          '?' +
          new Date().getTime() +
          `&${this.appinit.azureBlobTokenKey}`,
        { responseType: 'text' }
      )
      .subscribe(
        (data) => {
          this.appinit.injectStylesheet(data, 'groupDefaultStyles');
          this.getCanvasColor(data);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getCanvasColor(data) {
    let color1, color2;
    let stylesParse = data.split('/**');
    stylesParse.forEach((element, index) => {
      if (element) {
        element = element.substring(element.indexOf('=') + 1, element.indexOf('**/'));
        if (index == 1) {
          color1 = element;
        } else if (index == 2) {
          color2 = element;
        }
      }
    });
    this.changeTheme.next({ updateValue: 'update', color: color1, color1: color2 });
  }

  // Handle Error
  private handleError<T>(operation, result?: T) {
    return (error: any): Observable<T> => {
      return of(result);
    };
  }

  //Route Guard
  canActivate(route: ActivatedRouteSnapshot) {
    let currentRoute = route.data.route;
    let gropPermission = this.appinit.PropertyData.groupPermissions;
    if (!gropPermission.isGroupsAvailable) {
      this.resetLoginDetails();
      this.router.navigate([`/accessRestricted/${this.tenantId}/${this.propertyId}`]);
    }
    if (currentRoute != 'login') {
      if (currentRoute === 'planner') {
        let usertorage = sessionStorage.getItem('PlannerUser');
        if (this.plannerLogin) {
          return true;
        } else if (usertorage) {
          let data = JSON.parse(usertorage);
          this.login(data.user, data.password).then(
            (res: any) => {
              if (res.success) {
                this.router.navigate(['/wbe/group/' + this.tenantId + '/' + this.propertyId + '/planner']);
                return true;
              } else {
                this.redirectLogin();
                return false;
              }
            },
            (err) => {
              this.redirectLogin();
              return false;
            }
          );
        } else {
          this.redirectLogin();
          return false;
        }
      } else if (currentRoute === 'delegate') {
        let usertorage = sessionStorage.getItem('DelegateUser');
        if (this.delegateLogin) {
          return true;
        } else if (usertorage) {
          let data = JSON.parse(usertorage);
          this.login(data.user, data.password).then(
            (res: any) => {
              if (res.success) {
                this.router.navigate(['/wbe/group/' + this.tenantId + '/' + this.propertyId + '/delegate']);
                return true;
              } else {
                this.redirectLogin();
                return false;
              }
            },
            (err) => {
              this.redirectLogin();
              return false;
            }
          );
        } else {
          this.redirectLogin();
          return false;
        }
      }
    } else {
      this.resetLoginDetails();
      return true;
    }
  }

  redirectLogin() {
    this.resetLoginDetails();
    this.router.navigate(['/wbe/group/' + this.tenantId + '/' + this.propertyId + '/auth']);
  }

  resetLoginDetails() {
    sessionStorage.removeItem(`${this.appinit.tenantId}-${this.appinit.propertyId}-confirmation`);
    $('#groupStyles').remove();
    sessionStorage.removeItem('DelegateUser');
    sessionStorage.removeItem('PlannerUser');
    this.loginAuth = false;
    this.userName = '';
    this.groupDetails = '';
    this.grpEvents = '';
    this.groupInvDetails = '';
    this.plannerLogin = false;
    this.loginState.next('default');
    this.delegateLogin = false;
    this.groupStartDate = '';
    this.groupEndDate = '';
    this.shoulderStartDate = '';
    this.shoulderEndDate = '';
  }
  uploadFile(formData) {
    return fetch(this.appinit.getCloudDomainName() + '/wbe-admin-service/tenants/' + this.appinit.tenantId + '/uploadFile', {
      method: 'POST',
      body: formData,
      headers: this.isAzureB2CAuthenticationEnabled
        ? { Authorization: `Bearer ${this.commonDataService.token}` }
        : { 'Api-Key-Token': this.commonDataService.token },
    });
    // return this.http.post(this.appinit.getCloudDomainName() + '/wbe-admin-service/tenants/' + this.appinit.tenantId + '/uploadFile', formData, this.appinit.serviceHeaders);
  }

  private subject = new Subject<any>();
  public preloadStatus = false;

  sendData(message: any) {
    this.subject.next(message);
    if (message.status) {
      this.preloadStatus = true;
    }
  }

  clearData() {
    this.subject.next(null);
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }

  submitBookData(data): Observable<BookDataResponse> {
    let propertyname = this.appinit.PropertyData.PropNameKeyList.book;
    let servername = this.appinit.getserverDetails_book();
    let url =
      this.appinit.getCloudDomainName() +
      '/' +
      servername +
      '/tenants/' +
      data.tenant +
      ('/context/' + this.appinit.PropertyData.ContextId + '/') +
      'propertyName/' +
      propertyname +
      '?appName=wbe&locale=' +
      this.appinit.PropertyData.langCode +
      `&propertyId=${this.appinit.propertyId}`;
    return this.httpService.post(url, data, this.appinit.serviceHeaders).pipe(
      tap((res) => {
        return res;
      }),
      catchError(this.handleError('Booking Failed', {}))
    );
  }

  public getDeligateDetails(groupCode): Observable<any> {
    groupCode = this.urlEncode(groupCode);
    let deligateUrl =
      this.appinit.getCloudDomainName() +
      '/' +
      'wbe-rate-service/' +
      'grouplogin/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.appinit.propertyId +
      '/appName/' +
      this.appinit.appName +
      `/groupDelegate?appName=wbe&groupCode=${groupCode}`;
    return this.httpService.get(deligateUrl, this.appinit.serviceHeaders).pipe(
      tap((res) => {
        return res;
      }),
      catchError(this.handleError('Group Delegate details failed.', {}))
    );
  }

  public deleteImage(options): Observable<any> {
    let deleteUrl = this.appinit.getCloudDomainName() + '/' + 'wbe-admin-service/tenants/' + this.appinit.tenantId + '/deleteBlob';
    return this.httpService.delete(deleteUrl, options);
  }

  getZipCodeDetails(zipCode: any, address: any = ''): Observable<GetLocationApiResponse> {
    let url =
      this.appinit.getCloudDomainName() +
      '/' +
      this.servername +
      '/tenants/' +
      this.appinit.tenantId +
      `/getLocation?address=${encodeURIComponent(address)}&zipCode=${zipCode}`;
    return this.httpService.get(url, this.appinit.serviceHeaders).pipe(
      tap((data: GetLocationApiResponse) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }

  public getInventryDetails(groupId = this.groupDetails.groupId): Observable<any> {
    let deligateUrl =
      this.appinit.getCloudDomainName() +
      '/' +
      'wbe-rate-service/' +
      'grouplogin/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.appinit.propertyId +
      '/appName/' +
      this.appinit.appName +
      `/groupInventory?appName=wbe&groupId=${groupId}`;
    return this.httpService.get(deligateUrl, this.appinit.serviceHeaders).pipe(
      tap((res) => {
        return res;
      }),
      catchError(this.handleError('Group Inventry details failed.', {}))
    );
  }

  getPlannerConfigureData(groupcode) {
    groupcode = this.urlEncode(groupcode);
    let url = `${this.appinit.getCloudDomainName()}/${this.groupRateService}/group/tenants/${this.appinit.tenantId}/propertyId/${
      this.appinit.propertyId
    }/plannerconfig?groupId=${groupcode}&appName=wbe`;
    return this.httpService.get(url, this.appinit.serviceHeaders);
  }
}
